const getters = { //实时监听state值的变化(最新状态)
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  menu: state => state.app.menu,
  token: state => state.user.token,
  user: state => state.user.user,
  getAlarmInfo: state => state.alarmInfo,
  getNotiNum: state => state.notiNum,
  getvehicleSto: state => state.vehicleSto,
  getSignData: state => state.signData,
  getSigniNum: state => state.signiNum,
  iframeToken:state => state.iframeToken
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js